export default __webpack_public_path__ + "static/architecture-41e5123cfde85a8e26750756ec9ab4aa.png";